<template>
  <div v-if="permission && permission.version === '5'" class="job-board-page">
    <b-container fluid class="page_content">
      <div class="pg_toolbar job-board-toolbar">
        <div class="toolbar-left data-row">
          <div class="toolbar-title ace_sec_txt module_heading">
            <span class="ic2_job-briefcase"></span>
            <h1 class="head_txt module_type_name ace_sec_hd" role="heading" aria-level="1">
              {{ $t('jobs') }} [{{total}}]
            </h1>
          </div>
          <!-- Employer Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleEmployerDropDown" id="employerDropDown" class="form-field employer-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('employerFilter') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="employerDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="employerDropDown" :show.sync="showEmployerDropDown" container="employerDropDownPopup" triggers="blur">
              <div class="popup_content">
                <input type="text" class="input-search" :placeholder="$t('typeToFilterEmployer')" :aria-label="$t('typeToFilterEmployer')" v-model.trim="employerSearch">
                <div class="field-row" v-for="(emp, index) in filteredEmployers" :key="'employer-' + emp.value">
                  <input type="checkbox" :id="'employer-filter-' + index" :value="emp.value" v-model="employerSelected" @click.stop @input.stop>
                  <label :for="'employer-filter-' + index">{{ emp.text }}</label>
                </div>
              </div>
              <b-btn @click="toggleEmployerDropDown" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
          <!-- Job Type Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleJobDropDown" id="jobDropDown" class="form-field job-type-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('type') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="jobDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="jobDropDown" :show.sync="showJobTypeDropDown" container="jobDropDownPopup" triggers="blur">
              <div class="popup_content">
                <div class="field-row" v-for="(type, index) in jobType" :key="'jobType-' + type.value">
                  <input type="checkbox" :id="'jobType-filter-' + index" :value="type.value" v-model="jobTypeSelected" @click.stop @input.stop>
                  <label :for="'jobType-filter-' + index">{{ type.text }}</label>
                </div>
              </div>
              <b-btn @click="toggleJobDropDown" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
          <!-- Recommended Filter -->
          <div class="explore_filter" v-if="hasRecommendedJobs">
            <b-button
              @click.stop="toggleRecommendedFilter"
              id="recommendedFilter"
              class="form-field recommended-filter ace_sec"
              :class="{ 'is-active': showRecommendedOnly }"
              tabindex="0">
              <label>
                <span class="ic icon-star-full"></span>
                <span class="txt_sh">{{ $t('recommended') }}</span>
              </label>
            </b-button>
          </div>
          <!-- Salary Range Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleSalaryRangeDropDown" id="salaryRangeDropDown" class="form-field salary-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('salary') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="salaryRangeDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="salaryRangeDropDown" :show.sync="showSalaryRangeDropDown" container="salaryRangeDropDownPopup" triggers="blur">
              <div class="popup_content">
                <div class="field-row" v-for="(range, index) in salaryRangeGroups" :key="'salary-' + range.label">
                  <input type="checkbox" :id="'salary-filter-' + index" :value="range.label" v-model="salaryRangeSelected" @click.stop @input.stop>
                  <label :for="'salary-filter-' + index">{{ range.label }}</label>
                </div>
              </div>
              <b-btn @click="toggleSalaryRangeDropDown" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
          <!-- Distance Filter -->
          <div class="explore_filter">
            <b-button @click.stop="toggleDistanceDropDown" id="distanceDropDown" class="form-field distance-filter ace_sec" tabindex="0">
              <label>
                <span class="txt_sh">{{ $t('distance') }}</span>
                <span class="icon-dropdown1"></span>
              </label>
            </b-button>
            <div id="distanceDropDownPopup" class="dropdown_popover explore_filter_container"></div>
            <b-popover target="distanceDropDown" :show.sync="showDistanceDropDown" container="distanceDropDownPopup" triggers="manual">
              <div class="popup_content" @click.stop @mousedown.stop>
                <div class="field-row distance-location-row">
                  <div class="location-field city-field">
                    <label for="distanceCity">{{ $t('city') }}</label>
                    <input id="distanceCity" type="text" v-model.trim="distanceCity" :placeholder="$t('city')" @click.stop>
                  </div>
                  <div class="location-field state-field" @click.stop @mousedown.stop>
                    <label for="distanceState">{{ $t('state') }}</label>
                    <v-select
                      id="distanceState"
                      class="distance-state-select"
                      v-model="distanceState"
                      :options="usStates"
                      :placeholder="$t('selectState')"
                      :clearable="true"
                    ></v-select>
                  </div>
                </div>
                <div class="field-row" v-for="range in distanceOptions" :key="'distance-' + range.value">
                  <div class="form-check">
                    <input type="radio" class="form-check-input" :id="'distance-' + range.value" :value="range.value" v-model="distanceSelected">
                    <label class="form-check-label" :for="'distance-' + range.value">{{ range.label }}</label>
                  </div>
                </div>
              </div>
              <div class="distance-popup-actions">
                <b-btn @click="applyDistanceFilter" class="range-button">{{ $t('ok') }}</b-btn>
              </div>
            </b-popover>
          </div>
        </div>
        <div class="toolbar-right">
          <!--
          <div class="out-of-total-item ace_sec_txt">
            <div>{{total}} {{ $t('jobs').toLowerCase() }}</div>
          </div>
          -->
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions" :aria-label="$t('numberOfItem')">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
                <b-dropdown-item @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="pageNumber <= 1" @click="prevPage" @keydown.enter="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{pageNumber}}</span>
            <button type="button" class="btn btn_trans" :disabled="(from + size) >= total" @click="nextPage" @keydown.enter="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" :placeholder="$t('typeToNarrowResults')" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="$t('typeToNarrowResults')">
            <button class="btn btn_srh" @click="searchButtonClicked" :aria-label="$t('goAria')">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
            <button id="sortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec">
              <span class="ic2_sort2 sort-by-icon" aria-hidden="true"></span>
              <span class="txt_srt">{{ $t('sort') }}</span>
            </button>
            <div id="jobListSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="sortByDropDown" :show.sync='showSortByDropDown' container="jobListSortPopup" triggers="blur">
            <div class='header-content-row'>
              <span class="title">{{ $t('sortBy') }}</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
          </b-popover>
        </div>
      </div>

      <b-input-group class="job-board-filter-tags filter-tags-wrapper">
        <template v-for="(idxSelected, index) in (selectedFacets.jobTypeSelected || [])">
          <div class="search_tag filter-tag" :key="'jobType-' + index">
            <span class="title job-type-tag">{{ formatJobTypeLabel(idxSelected) }}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('jobTypeSelected', index)">
            </span>
          </div>
        </template>
        <template v-for="(idxSelected, index) in (selectedFacets.employerSelected || [])">
          <div class="search_tag filter-tag" :key="'employer-' + index">
            <span class="title employer-tag">{{idxSelected}}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('employerSelected', index)">
            </span>
          </div>
        </template>
        <template v-for="(idxSelected, index) in (selectedFacets.salaryRangeSelected || [])">
          <div class="search_tag filter-tag" :key="'salary-' + index">
            <span class="title salary-tag">{{idxSelected}}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('salaryRangeSelected', index)">
            </span>
          </div>
        </template>
        <div class="search_tag filter-tag" v-if="distanceSelected" key="distance">
          <span class="title distance-tag">{{ distanceFilterLabel }}</span>
          <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('distanceSelected')">
          </span>
        </div>
        <template v-for="(idxSelected, index) in tagSelected">
          <div class="search_tag filter-tag" :key="'job-tag-' + index">
            <span class="title job-applied-tag">{{idxSelected.name || idxSelected}}</span>
            <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('tagSelected', index)">
            </span>
          </div>
        </template>
        <div class="search_tag filter-tag" v-if="showRecommendedOnly && hasRecommendedJobs" key="recommended">
          <span class="title recommended-tag">{{ $t('recommended') }}</span>
          <span class="ic_btn ic_bin" :aria-label="$t('deleteAria')" tabindex="0" @click.stop="removeSelectedFacet('recommendedSelected')">
          </span>
        </div>
      </b-input-group>

      <div class="job-board-body">
      <div class="job-board-list">
      <b-row class="explore_entity_result">
        <div cols="12" class="datatable">
          <b-row class="search_result_container">
            <b-col cols="12">
              <b-list-group>
                <template v-if="results.length === 0">
                  <div class="msg_no_result ace_sec_txt">
                    {{ $t('noResult') }}
                  </div>
                </template>
                <template v-else>
                  <b-list-group-item class="flex-column align-items-start result_row" v-for="(result, index) in results" :key="result.uuid" :class="{ 'is-selected': result.uuid === selectedJobUuid }" @click="selectJob(result)">
                    <div>
                      <div class="result_block">
                        <div class="job-card-main">
                          <div class="job-header-row">
                            <div class="title ace_sec_txt" @click.stop="selectJob(result)" :id="'entity_' + index">
                            {{ result.title }}
                            <span class="recommendation-star" v-if="isRecommendedJob(result)" :title="$t('recommended')">
                              <span class="ic icon-star-full" aria-hidden="true"></span>
                            </span>
                            <template v-if="isBookmarkEnabled">
                              <span class="bookmarked ace_sec_txt"
                              :title="$t('removeThisJobFromBookmark')"
                              :aria-label="$t('removeThisJobFromBookmark')"
                              role="button"
                              tabindex="0"
                              v-if="isJobBookmark(result)"
                              @click.stop="deleteJobBookmark(result)"
                              @keydown.enter.stop="deleteJobBookmark(result)">
                                <span class="ic8-bookmark3" style="float:right" aria-hidden="true"></span>
                              </span>
                              <span class="ace_sec_txt"
                              :title="$t('bookmarkThisJob')"
                              :aria-label="$t('bookmarkThisJob')"
                              role="button"
                              tabindex="0"
                              v-else
                              @click.stop="bookmarkJob(result)"
                              @keydown.enter.stop="bookmarkJob(result)">
                                <span class="ic8-bookmark3" style="float:right" aria-hidden="true"></span>
                              </span>
                            </template>
                            </div>
                          </div>
                          <div class="job-employer">
                            <div
                              class="employer-avatar"
                              :class="{ 'has-logo': employerLogo(result) }"
                              :style="employerLogo(result) ? null : { background: avatarColor(index) }">
                              <img
                                v-if="employerLogo(result)"
                                :src="employerLogo(result)"
                                :alt="result.employer || ''">
                              <span v-else>{{ employerInitials(result.employer) }}</span>
                            </div>
                            <div class="facet-title ace_sec_txt">{{ result.employer }}</div>
                          </div>
                        </div>
                        <div class="job-meta-grid">
                          <div class="job-meta-item job-salary-item">
                            <div class="icon_container">
                              <span class="ic_salary"></span>
                            </div>
                            <div class="facet-title ace_sec_txt" :title="result.salaryRange || $t('na')">
                              {{ result.salaryRange || $t('na') }}
                            </div>
                          </div>
                          <div class="job-meta-item job-type-item">
                            <div class="icon_container">
                              <span class="ic2_part-full-time-job"></span>
                            </div>
                            <div class="facet-title ace_sec_txt">
                              {{ formatJobTypeLabel(jobTypeLabel(result)) }}
                            </div>
                          </div>
<!-- May be use Later
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic22-dateRange"></span>
                            </div>
                            <div class="ace_sec_txt">
                              Posted On {{ millisToDate(result.postedDate || result.creationTime) }}
                            </div>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="ic22-dateRange"></span>
                            </div>
                            <div class="ace_sec_txt">
                              Apply By {{ millisToDate(result.applyBy) }}
                            </div>
                          </div>
                          <div class="job-meta-item">
                            <div class="icon_container">
                              <span class="icon-location"></span>
                            </div>
                            <div class="ace_sec_txt">
                              {{ jobLocation(result) }}
                            </div>
                          </div>
                          <div class="job-meta-item job-tags-item">
                            <div class="icon_container">
                              <span class="ic22-tag2"></span>
                            </div>
                            <div class="details ace_sec_txt">
                            <template v-if="result && ((result.appliedTagMap && Object.values(result.appliedTagMap).some(t => t && t.length > 0)) || (result.careerCompetenciesList && result.careerCompetenciesList.length > 0))">
                              <div class="tags_container">
                                <div class="tags_cat">
                                  <div class="tag" v-for="item in visibleJobTags(result)" :key="item.key" :class="item.cssClass" :aria-label="item.name" tabindex="0">
                                    <span class="tag_name" :class="item.nameClass" :title="item.name">{{item.name}}</span>
                                    <span class="tag_lavel" v-if="item.level">{{item.level}}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="job-all-tags">
                                <div class="tags_cat" v-if="result.appliedTagMap" :id="'tagsRow_' + index">
                                  <template v-for="(values, key) in result.appliedTagMap">
                                    <div class="tag" v-for="tag in values" :key="tag.uuid || tag.name" :aria-label="tag.name" tabindex="0">
                                      <span class="tag_name instructional_tag" :title="tag.name">{{tag.name}}</span>
                                    </div>
                                  </template>
                                </div>
                                <div class="tags_cat" v-if="result.careerCompetenciesList && result.careerCompetenciesList.length > 0" :id="'specialTagsRow_' + index">
                                  <div class="tag" v-for="specialTag in result.careerCompetenciesList" :key="specialTag.uuid || specialTag.name" :class="specialTag.tagType" :aria-label="specialTag.name" tabindex="0">
                                    <span class="tag_name competency_tag" data-toggle="tooltip" data-placement="top" :title="specialTag.name">{{specialTag.name}}</span>
                                    <span class="tag_lavel" v-if="specialTag.fulfillLevels && specialTag.fulfillLevels.length > 0">
                                    {{specialTag.fulfillLevels[0]}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <b-button class="btn ic_btn btn_ellipsis"
                                v-if="hasMoreJobTags(result)"
                                @click="showTagsPopup('tagsRow_', 'specialTagsRow_', index)"
                                :aria-label="$t('showAllTags')"
                                :title="$t('showAllTags')"
                                v-b-tooltip.hover
                                tabindex="0">
                                <span class="module_icon ic9-iconMore-0005 ic_more"></span>
                              </b-button>
                            </template>
                            <template v-else>
                              <div class="no_tags">
                                <div class="empty_pattern ace_sec_txt">{{ $t('noTagAddedForThisJob') }}</div>
                              </div>
                            </template>
                          </div>
                          </div>
 -->

                        </div>
                      </div>
                      <div class="thumbnail ace_sec_txt">
                        <div class="thumbnail_default ico-job2" @click.stop="selectJob(result)" :aria-label="$t('job')"></div>
                      </div>
                    </div>
                  </b-list-group-item>
                </template>
              </b-list-group>
            </b-col>
          </b-row>
        </div>
      </b-row>
      </div>
      <div class="job-board-details">
        <job-home v-if="selectedJobUuid" :key="selectedJobUuid" :uuid="selectedJobUuid" :embedded="true" @filter-by-tag="filterJobsByTag"></job-home>
        <div v-else class="job-details-empty ace_sec_txt">
          {{ $t('selectJobToViewDetails') }}
        </div>
      </div>
      </div>
      <b-row>
        <div>
          <b-modal ref="tagsListPopup" :title="$t('tags')" class="modal__v22_2" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc centered>

            <div slot="modal-header" class="row header-section w-100">
    					<div class="col-11 hd">
    						<div class="ic_container">
                  <span class="ic ic-tag"></span>
    						</div>
    						<div class="hd_txt">
    							<span>{{ $t('tags') }}</span>
    						</div>
    					</div>
    					<div class="col-1 btn_container pr-0 mt-0">
    						<button class="btn_close" :aria-label="$t('closeAria')" @click="closeTagsPopup">
    							 <span class="ic-close"></span>
    						</button>
    					</div>
    				</div>

            <div class="details">
              <div class="tags_container" id="tagsListContainer">
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <div class="btn_container">
                <b-button type="button" class="btn" @click="closeTagsPopup">{{ $t('ok') }}</b-button>
              </div>
            </div>
          </b-modal>
        </div>
        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
              <div class="mt-4" v-if="loadingMessage">
                <span>{{loadingMessage}}</span>
              </div>
            </div>
          </b-modal>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { PACKAGE } from '../../../package_constants'
  import JobHome from '../../job/components/JobHome'
  import { getSimpleLibraryFilter } from '../searchUtils.js'
  import '../../../assets/module/sass/discover/discover.scss'

  const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']

  export default {
    name: 'jobResults',
    props: [],
    components: {
      JobHome
    },
    data: () => {
      return {
        folders: [],
        allFolders: [],
        foldersSelected: [],
        privateLibraryList: [],
        publicLibraryList: [],
        userId: '',
        libraryList: '',
        jobType: [],
        jobTypeSelected: [],
        employer: [],
        employerSelected: [],
        salaryRangeSelected: [],
        distanceSelected: '',
        distanceCity: '',
        distanceState: '',
        defaultDistanceCity: '',
        defaultDistanceState: '',
        userLat: null,
        userLon: null,
        usStates: US_STATES,
        distanceOptions: [
          { label: '10 miles', value: '10 miles' },
          { label: '25 miles', value: '25 miles' },
          { label: '50 miles', value: '50 miles' },
          { label: '100 miles', value: '100 miles' }
        ],
        tagSelected: [],
        recommendedJobIds: [],
        showRecommendedOnly: false,
        recommendedJobIdsLoaded: false,
        salaryRangeGroups: [
          { label: 'Below $25,000', minLt: 25000 },
          { label: '$25,000-$50,000', minGt: 25000, maxLt: 50000 },
          { label: '$50,000-$75,000', minGt: 50000, maxLt: 75000 },
          { label: '$75,000-$100,000', minGt: 75000, maxLt: 100000 },
          { label: '$100,000-$150,000', minGt: 100000, maxLt: 150000 },
          { label: 'Above $150,000', minGt: 150000 }
        ],
        indexList: 'job',
        facets: {},
        filter: {},
        source: ['title', 'uuid', 'name', 'description', 'type', 'employer', 'employerUuid', 'salaryRange', 'minSalary', 'maxSalary', 'contactInfo', 'jobTypes', 'geoLocation', 'creationTime', 'postedDate', 'applyBy', 'viewCount','applicantCount',  'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'master', 'careerCompetenciesMap', 'careerCompetenciesList', 'ownerId', 'ownerName'],
        sizeOptions: [ 10, 50, 100 ],
        ignoreFolderWatch: false,
        ignoreJobWatch: false,
        ignoreEmployerWatch: false,
        ignoreSalaryWatch: false,
        ignoreDistanceWatch: false,
        ignoreTagWatch: false,
        loadingMessage: null,
        showJobTypeDropDown : false,
        showEmployerDropDown: false,
        showSalaryRangeDropDown: false,
        showDistanceDropDown: false,
        showSortByDropDown: false,
        sorts: [
        {name: 'Relevance', clause: [{_score: {order: 'desc'}}]},
        {name: 'Title', labelKey: 'title', clause: [{'title.raw': {order: 'asc'}}]},
        {name: 'Employer', labelKey: 'employerFilter', clause: [{'employer.keyword': {order: 'asc'}}]},
        {name: 'Posted On', labelKey: 'postedOn', clause: [{creationTime: {order: 'desc'}}]},
        {name: 'Apply By', labelKey: 'applyBy', clause: [{applyBy: {order: 'asc'}}]},
        {name: 'Salary', clause: [{minSalary: {order: 'asc'}}]},
        {name: 'Distance', labelKey: 'distance', clause: []}
        ],
        selectedSortName: 'Title',
        searchTerms: '',
        employerSearch: '',
        selectedJobUuid: null,
        avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c']
      }
    },

    computed: {
      ...mapState({
        'results': state => state.search.results,
        'total': state => state.search.total,
        'from': state => state.search.from,
        'pageNumber': state => state.search.pageNumber,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'size': state => state.search.size,
        'facetResults': state => state.search.aggregations,
        'libraryPositionMapping': state => state.search.libraryPositionMapping,
        'permission': state => state.user.permission,
        'bookmarks': state => state.explore.bookmarks,
        'institution' : state => state.institution.institution,
        'selectedFacets': state => state.search.selectedFacets
      }),
      isBookmarkEnabled () {
        let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
        if (bookmarkFeature && bookmarkFeature.enabled) {
          return true
        }
        return false
      },
      hasRecommendedJobs () {
        return this.recommendedJobIds && this.recommendedJobIds.length > 0
      },
      selectedSort () {
        if (this.selectedSortName === 'Distance' && this.hasUserLocation) {
          return [this.geoDistanceSort()]
        }
        let selected = this.sorts.find((sort) => {
          return sort.name === this.selectedSortName
        })
        if (!selected || !selected.clause || selected.clause.length === 0) {
          selected = this.sorts[1]
        }
        let clause = selected.clause.slice()
/* If we want to pinned the recommendations on Top
        if (this.hasRecommendedJobs) {
          clause.unshift(this.recommendedFirstSort())
        }
*/
        return clause
      },
      hasUserLocation () {
        return typeof this.userLat === 'number' && typeof this.userLon === 'number' &&
          !isNaN(this.userLat) && !isNaN(this.userLon)
      },
      distanceFilterLabel () {
        let found = this.distanceOptions.find((range) => {
          return range.value === this.distanceSelected
        })
        let rangeLabel = found ? found.label : this.distanceSelected
        let place = [this.distanceCity, this.distanceState].filter(Boolean).join(', ')
        if (place) {
          return rangeLabel + ' of ' + place
        }
        return rangeLabel
      },
      filteredEmployers () {
        let employers = this.employer
        if (employers && employers.length > 0) {
          return employers.filter(item => {
            let name = item.value || item.text || ''
            return name.toLowerCase().indexOf(this.employerSearch.toLowerCase()) > -1
          })
        }
        return employers
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.query._) {
          this.populateUserLibrary()
          return
        }
        let toEmployer = (to.query && to.query.employer) || ''
        let fromEmployer = (from && from.query && from.query.employer) || ''
        let toTag = (to.query && to.query.tag) || ''
        let fromTag = (from && from.query && from.query.tag) || ''
        if (toEmployer !== fromEmployer) {
          this.applyIncomingEmployerFilter()
          this.constructQuery()
        }
        if (toTag !== fromTag) {
          this.applyIncomingTagFilter()
          this.constructQuery()
        }
      },
      facetResults () {
        this.processFacetResult(this.facetResults.jobType, 'jobType')
        this.processFacetResult(this.facetResults.employer, 'employer')
      },
      foldersSelected () {
        if (this.ignoreFolderWatch) {
          this.ignoreFolderWatch = false
        } else {
          this.updateFacet()
        }
      },
      jobTypeSelected () {
        if (this.ignoreJobWatch) {
          this.ignoreJobWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'jobTypeSelected', value: this.jobTypeSelected})
        }
      },
      employerSelected () {
        if (this.ignoreEmployerWatch) {
          this.ignoreEmployerWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'employerSelected', value: this.employerSelected})
        }
      },
      salaryRangeSelected () {
        if (this.ignoreSalaryWatch) {
          this.ignoreSalaryWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'salaryRangeSelected', value: this.salaryRangeSelected})
        }
      },
      distanceSelected () {
        if (this.ignoreDistanceWatch) {
          this.ignoreDistanceWatch = false
        } else {
          this.storeSelectedFactes({key: 'distanceSelected', value: this.distanceSelected ? [this.distanceSelected] : []})
        }
      },
      tagSelected () {
        if (this.ignoreTagWatch) {
          this.ignoreTagWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'tagSelected', value: this.tagSelected})
        }
      },
      results () {
        this.syncSelectedJob()
      }
    },
    mounted () {
      this.showLoader()
      this.updatePageNumber(1)
      this.updateFrom(0)
      this.loadAllBookmarks()
      this.loadPermission().then(res => {
        this.loadLibraryPositionMapping()
        this.populateUserLibrary()
      })
    },
    methods: {
      ...mapActions([
        'loadUserInfo',
        'loadAllLibraryForUser',
        'constructSearchQuery',
        'updateFrom',
        'updatePageNumber',
        'updateSize',
        'loadLibraryPositionMapping',
        'loadPermission',
        'storeSelectedFactes',
        'loadCreateBookmarks',
        'loadDeleteBookmark',
        'loadAllBookmarks',
        'loadAllJobIdsWithRecommendation'
      ]),
      closeOtherFilterPopups (keep) {
        if (keep !== 'employer') {
          if (this.showEmployerDropDown) {
            this.employerSearch = ''
          }
          this.showEmployerDropDown = false
        }
        if (keep !== 'jobType') {
          this.showJobTypeDropDown = false
        }
        if (keep !== 'salary') {
          this.showSalaryRangeDropDown = false
        }
        if (keep !== 'distance') {
          this.showDistanceDropDown = false
        }
        if (keep !== 'sort') {
          this.showSortByDropDown = false
        }
      },
      toggleJobDropDown () {
        let open = !this.showJobTypeDropDown
        this.closeOtherFilterPopups('jobType')
        this.showJobTypeDropDown = open
      },
      toggleSalaryRangeDropDown () {
        let open = !this.showSalaryRangeDropDown
        this.closeOtherFilterPopups('salary')
        this.showSalaryRangeDropDown = open
      },
      toggleDistanceDropDown () {
        if (this.showDistanceDropDown) {
          this.showDistanceDropDown = false
          return
        }
        this.closeOtherFilterPopups('distance')
        this.showDistanceDropDown = true
        this.ensureDefaultCityState()
      },
      async applyDistanceFilter () {
        this.showDistanceDropDown = false
        if (this.distanceSelected) {
          let resolved = await this.resolveDistanceLocation()
          if (!resolved) {
            this.ignoreDistanceWatch = true
            this.distanceSelected = ''
            this.storeSelectedFactes({key: 'distanceSelected', value: []})
            return
          }
          this.storeSelectedFactes({key: 'distanceSelected', value: [this.distanceSelected]})
        } else {
          this.storeSelectedFactes({key: 'distanceSelected', value: []})
        }
        this.updateFacet()
      },
      async ensureDefaultCityState () {
        if (this.distanceCity || this.distanceState) {
          return
        }
        let located = await this.ensureUserLocation({ notify: false })
        if (!located) {
          return
        }
        await this.reverseGeocodeCurrentLocation()
      },
      async resolveDistanceLocation () {
        let city = (this.distanceCity || '').trim()
        let state = (this.distanceState || '').trim()
        let locationChanged = city !== this.defaultDistanceCity || state !== this.defaultDistanceState
        if (city || state) {
          if (locationChanged || !this.hasUserLocation) {
            return this.geocodeCityState(city, state)
          }
          return true
        }
        return this.ensureUserLocation()
      },
      geocodeCityState (city, state) {
        let query = [city, state, 'USA'].filter(Boolean).join(', ')
        let url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=1&q=' + encodeURIComponent(query)
        return fetch(url, { headers: { 'Accept': 'application/json' } }).then((res) => {
          if (!res.ok) {
            throw new Error('geocode failed')
          }
          return res.json()
        }).then((results) => {
          if (!results || !results.length || !results[0].lat || !results[0].lon) {
            this.notifyFailure('Unable to find that city and state.')
            return false
          }
          this.userLat = Number(results[0].lat)
          this.userLon = Number(results[0].lon)
          if (isNaN(this.userLat) || isNaN(this.userLon)) {
            this.notifyFailure('Unable to find that city and state.')
            return false
          }
          return true
        }).catch(() => {
          this.notifyFailure('Unable to find that city and state.')
          return false
        })
      },
      reverseGeocodeCurrentLocation () {
        if (!this.hasUserLocation) {
          return Promise.resolve()
        }
        let url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=10&addressdetails=1&lat=' + this.userLat + '&lon=' + this.userLon
        return fetch(url, { headers: { 'Accept': 'application/json' } }).then((res) => {
          if (!res.ok) {
            return null
          }
          return res.json()
        }).then((result) => {
          if (!result || !result.address) {
            return
          }
          let parsed = this.parseNominatimAddress(result.address)
          this.distanceCity = parsed.city
          this.distanceState = parsed.state
          this.defaultDistanceCity = parsed.city
          this.defaultDistanceState = parsed.state
        }).catch(() => {})
      },
      parseNominatimAddress (address) {
        let city = address.city || address.town || address.village || address.hamlet || address.municipality || ''
        let state = address.state || ''
        if (state && this.usStates.indexOf(state) === -1) {
          let match = this.usStates.find((name) => {
            return name.toLowerCase() === state.toLowerCase()
          })
          if (match) {
            state = match
          }
        }
        return { city: city, state: state }
      },
      needsUserLocation () {
        return !!this.distanceSelected || this.selectedSortName === 'Distance'
      },
      geoDistancePoint () {
        return {
          lat: this.userLat,
          lon: this.userLon
        }
      },
      geoDistanceSort () {
        return {
          _geo_distance: {
            geoLocation: this.geoDistancePoint(),
            order: 'asc',
            unit: 'mi',
            ignore_unmapped: true
          }
        }
      },
      isSecureGeolocationContext () {
        if (typeof window === 'undefined') {
          return false
        }
        if (window.isSecureContext) {
          return true
        }
        return false
      },
      getBrowserPosition (options, waitMs) {
        return new Promise((resolve, reject) => {
          let settled = false
          let wait = waitMs || 25000
          let timer = setTimeout(() => {
            if (settled) {
              return
            }
            settled = true
            reject({ code: 3, message: 'Timeout' })
          }, wait)
          try {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                if (settled) {
                  return
                }
                settled = true
                clearTimeout(timer)
                resolve(position)
              },
              (error) => {
                if (settled) {
                  return
                }
                settled = true
                clearTimeout(timer)
                reject(error)
              },
              options
            )
          } catch (error) {
            if (settled) {
              return
            }
            settled = true
            clearTimeout(timer)
            reject(error)
          }
        })
      },
      getBrowserPositionViaWatch (waitMs) {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation || !navigator.geolocation.watchPosition) {
            reject({ code: 2, message: 'watchPosition unavailable' })
            return
          }
          let settled = false
          let watchId = null
          let finish = (handler, value) => {
            if (settled) {
              return
            }
            settled = true
            clearTimeout(timer)
            if (watchId != null) {
              navigator.geolocation.clearWatch(watchId)
            }
            handler(value)
          }
          let timer = setTimeout(() => {
            finish(reject, { code: 3, message: 'Timeout' })
          }, waitMs || 20000)
          try {
            watchId = navigator.geolocation.watchPosition(
              (position) => {
                finish(resolve, position)
              },
              (error) => {
                finish(reject, error)
              },
              { enableHighAccuracy: false, maximumAge: 600000 }
            )
          } catch (error) {
            finish(reject, error)
          }
        })
      },
      locationErrorMessage (error) {
        let code = error && error.code
        if (!this.isSecureGeolocationContext()) {
          return 'Chrome requires https to read your location. Enter a city and state, or open the site with https.'
        }
        if (code === 1) {
          return 'Location permission is blocked. Enter a city and state, or allow location for this site in Chrome.'
        }
        if (code === 3) {
          return 'Location request timed out. Enter a city and state, or try Allow again.'
        }
        return 'Unable to get your current location. Enter a city and state.'
      },
      applyBrowserPosition (position) {
        if (!position || !position.coords) {
          return false
        }
        let lat = Number(position.coords.latitude)
        let lon = Number(position.coords.longitude)
        if (isNaN(lat) || isNaN(lon)) {
          return false
        }
        this.userLat = lat
        this.userLon = lon
        return true
      },
      async ensureUserLocation (options) {
        let notify = !(options && options.notify === false)
        if (this.hasUserLocation) {
          return true
        }
        if (!navigator.geolocation) {
          if (notify) {
            this.notifyFailure('Location is not available on this device. Enter a city and state.')
          }
          return false
        }
        if (!this.isSecureGeolocationContext()) {
          if (notify) {
            this.notifyFailure(this.locationErrorMessage({ code: 1 }))
          }
          return false
        }
        let attempts = [
          { enableHighAccuracy: false, maximumAge: 600000 },
          { enableHighAccuracy: false, maximumAge: 0 }
        ]
        let lastError = null
        for (let i = 0; i < attempts.length; i++) {
          try {
            let position = await this.getBrowserPosition(attempts[i], 25000)
            if (this.applyBrowserPosition(position)) {
              return true
            }
          } catch (error) {
            lastError = error
            if (error && error.code === 1) {
              break
            }
          }
        }
        if (!(lastError && lastError.code === 1)) {
          try {
            let position = await this.getBrowserPositionViaWatch(20000)
            if (this.applyBrowserPosition(position)) {
              return true
            }
          } catch (error) {
            lastError = error
          }
        }
        if (notify) {
          this.notifyFailure(this.locationErrorMessage(lastError))
        }
        return false
      },
      toggleEmployerDropDown () {
        let open = !this.showEmployerDropDown
        this.closeOtherFilterPopups('employer')
        this.showEmployerDropDown = open
        if (!open) {
          this.employerSearch = ''
        }
      },
      async toggleRecommendedFilter () {
        this.closeOtherFilterPopups()
        if (!this.showRecommendedOnly) {
          await this.loadRecommendedJobIds()
        }
        this.showRecommendedOnly = !this.showRecommendedOnly
        this.storeSelectedFactes({key: 'recommendedSelected', value: this.showRecommendedOnly ? ['Recommended'] : []})
        this.updateFacet()
      },
      searchButtonClicked () {
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.constructQuery()
      },
      toggleSortByDropDown () {
        let open = !this.showSortByDropDown
        this.closeOtherFilterPopups('sort')
        this.showSortByDropDown = open
      },
      async sortOkClicked () {
        this.showSortByDropDown = false
        if (this.selectedSortName === 'Distance') {
          let resolved = await this.resolveDistanceLocation()
          if (!resolved) {
            this.selectedSortName = 'Title'
            return
          }
        }
        this.constructQuery()
      },
      millisToDate (millis) {
        if (!millis) {
          return this.$t('na')
        }
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },
      formatJobTypeLabel (value) {
        if (!value) {
          return value
        }
        let text = String(value).replace(/[_-]+/g, ' ')
        text = text.replace(/([a-z])([A-Z])/g, '$1 $2')
        text = text.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        let compact = text.replace(/\s+/g, '').toLowerCase()
        let known = {
          fulltime: 'Full Time',
          parttime: 'Part Time'
        }
        if (known[compact]) {
          return known[compact]
        }
        return text.replace(/\s+/g, ' ').trim()
      },
      jobTypeLabel (result) {
        if (result && result.jobTypes && result.jobTypes.length > 0) {
          return result.jobTypes[0]
        }
        return this.$t('na')
      },
      employerLogo (result) {
        if (!result) {
          return ''
        }
        return result.thumbnail || result.thumbnailURI || ''
      },
      employerInitials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      jobLocation (result) {
        if (result && result.contactInfo && result.contactInfo.addresses && result.contactInfo.addresses.length > 0) {
          let address = result.contactInfo.addresses[0]
          let city = address.city || ''
          let state = address.state || ''
          if (city && state) {
            return city + ', ' + state
          }
          return city || state || this.$t('na')
        }
        return this.$t('na')
      },
      populateUserLibrary () {
        this.showLoader()
        this.userId = localStorage.getItem('userid')
        this.setupUserLibraries()
      },
      sortLibrariesIntoStandardOrder (libraries) {
        var sortedLibraryList = []
        for (var attr in this.libraryPositionMapping) {
          var value = this.libraryPositionMapping[attr]
          for (var i = 0; i < libraries.length; i++) {
            var library = libraries[i]
            if (this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },
      libraryMatches (library, value) {
        if (!library || !library.category) {
          return false
        }
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },
      async bookmarkJob (job) {
        const bookmark = {
          'source': 'explore',
          'entityType': 'job',
          'entityTitle': job.title,
          'entityUuid': job.uuid,
          'institutionId': job.employerId,
          'userId': this.userId
        }
        const response = await this.loadCreateBookmarks(bookmark)
        const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + job.title + '\''
        const notify = response ? this.notifySuccess : this.notifyFailure
        notify(message)
        await this.loadAllBookmarks()
      },

      async deleteJobBookmark (job) {
        await this.loadDeleteBookmark(job.bookmark.uuid)
        this.notifySuccess('Successfully deleted bookmark \'' + job.title + '\'')
        await this.loadAllBookmarks()
      },
      notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    isJobBookmark (job) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === job.uuid) {
          target = bookmark
          job.bookmark = bookmark
        }
      })
      return target
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
      updateFacet () {
        this.showLoader()
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.constructQuery()
      },
      setupUserLibraries () {
        this.loadUserInfo().then(res => {
          let userPreferences = res.userPreferences || {}
          let selectedLearningSpaces = userPreferences.learningSpaces || []
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = []
            this.allFolders = []
            this.foldersSelected = []
            this.publicLibraryList = []
            this.privateLibraryList = []
            this.ignoreFolderWatch = true
            let learningSpaces = this.sortLibrariesIntoStandardOrder(libraries)
            if (learningSpaces && learningSpaces.length > 0) {
              for (var i = 0; i < learningSpaces.length; i++) {
                let learningSpace = learningSpaces[i]
                const category = learningSpace.category
                if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
                  this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
                  this.ignoreFolderWatch = true
                  this.allFolders.push(learningSpace.uuid)
                  if (selectedLearningSpaces.includes(learningSpace.uuid)) {
                    this.foldersSelected.push(learningSpace.uuid)
                  }
                  if (category !== 'Institute' && category !== 'User_Private') {
                    this.publicLibraryList.push(learningSpace.uuid)
                  }
                  if (category === 'User_Private') {
                    this.privateLibraryList.push(learningSpace.uuid)
                  }
                }
              }
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.populateSelectedFacetsFromState()
                })
              })
            }

            let employerMappings = (this.institution && this.institution.institutionEmployerMapping) ? this.institution.institutionEmployerMapping : []
            employerMappings.forEach((mapping) => {
              if (mapping.status === 'Approved') {
                this.publicLibraryList.push(mapping.employerLibraryId)
                this.foldersSelected.push(mapping.employerLibraryId)
              }
            })

            this.applyIncomingEmployerFilter()
            this.applyIncomingTagFilter()
            this.loadRecommendedJobIds().then(() => {
              if (!this.hasRecommendedJobs && this.showRecommendedOnly) {
                this.showRecommendedOnly = false
                this.storeSelectedFactes({key: 'recommendedSelected', value: []})
              }
              this.constructQuery()
            })
          })
        })
      },
      showLoader (message) {
        if (this.$refs.loadingModal) {
          this.loadingMessage = message
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.loadingMessage = null
          this.$refs.loadingModal.hide()
        }
      },
      redirectToResult (result) {
        this.selectJob(result)
      },
      selectJob (result) {
        if (result && result.uuid) {
          this.selectedJobUuid = result.uuid
        }
      },
      syncSelectedJob () {
        if (!this.results || this.results.length === 0) {
          this.selectedJobUuid = null
          return
        }
        let stillVisible = this.results.some((item) => {
          return item.uuid === this.selectedJobUuid
        })
        if (!stillVisible) {
          this.selectedJobUuid = this.results[0].uuid
        }
      },
      changeSize (option) {
        this.updateSize(option)
        this.updateFrom(0)
        this.updatePageNumber(1)
        this.constructQuery()
      },
      showTagsPopup (tagsRow, specialTagsRow, index) {
        if (!tagsRow || !specialTagsRow || index === undefined || index === null) {
          return
        }
        this.$refs.tagsListPopup.show()
        let tagsRowId = tagsRow + index
        let tagsList = $('#' + tagsRowId).html()
        let specialTagsRowId = specialTagsRow + index
        let specialTagsList = $('#' + specialTagsRowId).html()
        $('#tagsListContainer').html(tagsList).append(specialTagsList)
      },
      jobTags (result) {
        let tags = []
        if (!result) {
          return tags
        }
        let appliedTagMap = result.appliedTagMap
        if (appliedTagMap) {
          Object.keys(appliedTagMap).forEach((key) => {
            let values = appliedTagMap[key]
            if (values && values.length) {
              for (let i = 0; i < values.length; i++) {
                let tag = values[i]
                tags.push({
                  key: 'applied-' + (tag.uuid || tag.name || i),
                  name: tag.name,
                  nameClass: 'instructional_tag',
                  cssClass: '',
                  level: ''
                })
              }
            }
          })
        }
        let competencies = result.careerCompetenciesList
        if (competencies && competencies.length) {
          for (let i = 0; i < competencies.length; i++) {
            let tag = competencies[i]
            let level = ''
            if (tag.fulfillLevels && tag.fulfillLevels.length > 0) {
              level = tag.fulfillLevels[0]
            }
            tags.push({
              key: 'competency-' + (tag.uuid || tag.name || i),
              name: tag.name,
              nameClass: 'competency_tag',
              cssClass: tag.tagType || '',
              level: level
            })
          }
        }
        return tags
      },
      visibleJobTags (result) {
        return this.jobTags(result).slice(0, 1)
      },
      hasMoreJobTags (result) {
        return this.jobTags(result).length > 1
      },
      closeTagsPopup () {
        this.$refs.tagsListPopup.hide()
      },
      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.constructQuery()
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.constructQuery()
        }
      },
      resetLocalFields () {
        this.libraryList = ''
      },
      buildFacet (field, size, order) {
        return {
          'aggs': {
            'termObj': {
              'terms': {
                'field': field,
                'size': size,
                'order': order
              }
            }
          },
          'filter': this.getFacetFilter()
        }
      },
      processFacetResult (facetResult, facetListName) {
        if (!facetResult) {
          return
        }
        this[facetListName] = []
        let terms = facetResult.termObj.buckets
        for (var i = 0; i < terms.length; i++) {
          let label = facetListName === 'jobType' ? this.formatJobTypeLabel(terms[i].key) : terms[i].key
          let term = {
            'text': label + ' [' + terms[i].doc_count + ']',
            'value': terms[i].key
          }
          this[facetListName].push(term)
        }
      },
      async constructQuery () {
        this.resetLocalFields()
        this.libraryList = this.allFolders.join(',')
        this.indexList = 'job'

        this.facets = {
          'jobType': this.buildFacet('jobTypes.raw', 100, {'_key': 'asc'}),
          'employer': this.buildFacet('employer.keyword', 1000, {'_key': 'asc'})
        }

        if (this.needsUserLocation()) {
          let located = this.hasUserLocation
          if (!located) {
            located = await this.resolveDistanceLocation()
          }
          if (!located) {
            if (this.distanceSelected) {
              this.ignoreDistanceWatch = true
              this.distanceSelected = ''
              this.storeSelectedFactes({key: 'distanceSelected', value: []})
            }
            if (this.selectedSortName === 'Distance') {
              this.selectedSortName = 'Title'
            }
          }
        }

        this.filter = this.generateFilter()
        await this.constructSearchQuery({ terms: this.searchTerms, sort: this.selectedSort, preserveSort: true, source: this.source, from: this.from, size: this.size, indexList: this.indexList, libraryList: this.libraryList, privateLibraryList: this.privateLibraryList, publicLibraryList: this.publicLibraryList, userId: this.userId, aggs: this.facets, filter: this.filter })
        this.hideLoader()
      },
      generateFilter () {
        var filterObj = {
          'bool': this.originUuidCheck()
        }

        if (this.foldersSelected.length > 0) {
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(this.foldersSelected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        } else {
          let selected = []
          this.folders.forEach((folder) => {
            selected.push(folder.value)
          })
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(selected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        }

        filterObj.bool.must.push({
          'terms': {
            '_type': ['Job']
          }
        })

        if (this.jobTypeSelected.length > 0) {
          filterObj.bool.must.push({
            'terms': {
              'jobTypes.raw': this.jobTypeSelected
            }
          })
        }
        if (this.employerSelected.length > 0) {
          filterObj.bool.must.push({
            'terms': {
              'employer.keyword': this.employerSelected
            }
          })
        }
        if (this.salaryRangeSelected.length > 0) {
          let salaryQueries = this.selectedSalaryRangeQueries()
          if (salaryQueries.length === 1) {
            filterObj.bool.must.push(salaryQueries[0])
          } else if (salaryQueries.length > 1) {
            filterObj.bool.must.push({
              'bool': {
                'should': salaryQueries,
                'minimum_should_match': 1
              }
            })
          }
        }
        if (this.tagSelected.length > 0) {
          filterObj.bool.must.push(this.buildTagFilter())
        }
        if (this.showRecommendedOnly) {
          if (this.recommendedJobIds.length > 0) {
            filterObj.bool.must.push({
              'terms': {
                'uuid': this.recommendedJobIds
              }
            })
          } else {
            filterObj.bool.must.push({
              'bool': {
                'must_not': {
                  'match_all': {}
                }
              }
            })
          }
        }
        if (this.distanceSelected && this.hasUserLocation) {
          filterObj.bool.must.push({
            'geo_distance': {
              'distance': this.distanceSelected,
              'distance_type': 'arc',
              'geoLocation': {
                'lat': Number(this.userLat),
                'lon': Number(this.userLon)
              }
            }
          })
        }
        return filterObj
      },
      getFacetFilter () {
        return {
          'bool': this.originUuidCheck()
        }
      },
      originUuidCheck () {
        var originUuidCheck = {
          'must': [],
          'must_not': {
            'exists': {
              'field': 'originUuid'
            }
          }
        }
        return originUuidCheck
      },
      populateSelectedFacetsFromState () {
        this.ignoreJobWatch = true
        this.jobTypeSelected = this.selectedFacets.jobTypeSelected || []
        this.ignoreEmployerWatch = true
        if (this.$route.query.employer) {
          this.employerSelected = [this.$route.query.employer]
        } else {
          this.employerSelected = []
        }
        this.ignoreSalaryWatch = true
        this.salaryRangeSelected = this.selectedFacets.salaryRangeSelected || []
        this.ignoreDistanceWatch = true
        this.distanceSelected = (this.selectedFacets.distanceSelected && this.selectedFacets.distanceSelected[0]) || ''
        this.ignoreTagWatch = true
        if (this.$route.query.tag) {
          this.tagSelected = [this.normalizeTagSelection(this.$route.query.tag)]
        } else {
          this.tagSelected = this.selectedFacets.tagSelected || []
        }
        this.showRecommendedOnly = !!(this.hasRecommendedJobs && this.selectedFacets.recommendedSelected && this.selectedFacets.recommendedSelected.length)
      },
      applyIncomingTagFilter () {
        let tagName = this.$route.query.tag
        if (!tagName) {
          return
        }
        this.ignoreTagWatch = true
        this.tagSelected = [this.normalizeTagSelection(tagName)]
        this.storeSelectedFactes({key: 'tagSelected', value: this.tagSelected})
      },
      filterJobsByTag (tag) {
        let selected = this.normalizeTagSelection(tag)
        if (!selected.name) {
          return
        }
        let exists = this.tagSelected.some((item) => {
          return this.tagSelectionName(item) === selected.name
        })
        if (!exists) {
          this.tagSelected.push(selected)
        }
      },
      normalizeTagSelection (tag) {
        if (!tag) {
          return { name: '', category: '' }
        }
        if (typeof tag === 'string') {
          return { name: tag, category: '' }
        }
        return {
          name: tag.name || '',
          category: tag.category || ''
        }
      },
      tagSelectionName (tag) {
        if (!tag) {
          return ''
        }
        return tag.name || tag
      },
      buildTagFilter () {
        let must = []
        this.tagSelected.forEach((tag) => {
          let selected = this.normalizeTagSelection(tag)
          if (!selected.name) {
            return
          }
          let should = []
          if (selected.category) {
            let terms = {}
            terms['appliedTagMap.' + selected.category + '.name'] = [selected.name]
            should.push({
              'terms': terms
            })
          }
          should.push({
            'query_string': {
              'query': '"' + String(selected.name).replace(/"/g, '') + '"',
              'fields': ['appliedTagMap.*.name']
            }
          })
          should.push({
            'terms': {
              'careerCompetenciesList.name': [selected.name]
            }
          })
          should.push({
            'terms': {
              'careerCompetenciesList.name.keyword': [selected.name]
            }
          })
          must.push({
            'bool': {
              'should': should,
              'minimum_should_match': 1
            }
          })
        })
        return {
          'bool': {
            'must': must
          }
        }
      },
      applyIncomingEmployerFilter () {
        let employerName = this.$route.query.employer
        this.ignoreEmployerWatch = true
        if (employerName) {
          this.employerSelected = [employerName]
          this.storeSelectedFactes({key: 'employerSelected', value: [employerName]})
        } else {
          this.employerSelected = []
          this.storeSelectedFactes({key: 'employerSelected', value: []})
        }
      },
      removeSelectedFacet (key, index) {
        if (key === 'jobTypeSelected') {
          this.jobTypeSelected.splice(index, 1)
        } else if (key === 'employerSelected') {
          this.employerSelected.splice(index, 1)
        } else if (key === 'salaryRangeSelected') {
          this.salaryRangeSelected.splice(index, 1)
        } else if (key === 'tagSelected') {
          let removed = this.tagSelectionName(this.tagSelected[index])
          this.tagSelected.splice(index, 1)
          if (this.$route.query.tag && this.$route.query.tag === removed) {
            let query = Object.assign({}, this.$route.query)
            delete query.tag
            this.$router.replace({ query: query })
          }
        } else if (key === 'distanceSelected') {
          this.ignoreDistanceWatch = true
          this.distanceSelected = ''
          this.storeSelectedFactes({key: 'distanceSelected', value: []})
          this.updateFacet()
        } else if (key === 'recommendedSelected') {
          this.showRecommendedOnly = false
          this.storeSelectedFactes({key: 'recommendedSelected', value: []})
          this.updateFacet()
        }
      },
      salaryRangeQuery (group) {
        let must = []
        if (group.minLt !== undefined) {
          must.push({
            'range': {
              'minSalary': { 'lt': group.minLt }
            }
          })
        }
        if (group.minGt !== undefined) {
          must.push({
            'range': {
              'minSalary': { 'gt': group.minGt }
            }
          })
        }
        if (group.maxLt !== undefined) {
          must.push({
            'range': {
              'maxSalary': { 'lt': group.maxLt }
            }
          })
        }
        if (must.length === 1) {
          return must[0]
        }
        return {
          'bool': {
            'must': must
          }
        }
      },
      selectedSalaryRangeQueries () {
        let queries = []
        for (let i = 0; i < this.salaryRangeGroups.length; i++) {
          let group = this.salaryRangeGroups[i]
          if (this.salaryRangeSelected.indexOf(group.label) !== -1) {
            queries.push(this.salaryRangeQuery(group))
          }
        }
        return queries
      },
      isRecommendedJob (job) {
        return !!(job && job.uuid && this.recommendedJobIds.indexOf(job.uuid) !== -1)
      },
      recommendedFirstSort () {
        return {
          '_script': {
            'type': 'number',
            'order': 'asc',
            'script': {
              'lang': 'painless',
              'source': "def id = ''; if (doc.containsKey('uuid.keyword') && doc['uuid.keyword'].size() != 0) { id = doc['uuid.keyword'].value; } return params.ids.contains(id) ? 0 : 1;",
              'params': {
                'ids': this.recommendedJobIds.slice()
              }
            }
          }
        }
      },
      normalizeRecommendedJobIds (res) {
        let list = res
        if (res && res.data && Array.isArray(res.data)) {
          list = res.data
        }
        if (!Array.isArray(list)) {
          list = list ? [list] : []
        }
        let ids = []
        list.forEach(item => {
          let id = ''
          if (typeof item === 'string') {
            id = item
          } else if (item) {
            id = item.uuid || item.jobUuid || item.jobId || item.entityUuid || item.entityId || ''
          }
          if (id && ids.indexOf(id) === -1) {
            ids.push(id)
          }
        })
        return ids
      },
      loadRecommendedJobIds () {
        if (this.recommendedJobIdsLoaded) {
          return Promise.resolve(this.recommendedJobIds)
        }
        return this.loadAllJobIdsWithRecommendation().then(res => {
          this.recommendedJobIds = this.normalizeRecommendedJobIds(res)
          this.recommendedJobIdsLoaded = true
          return this.recommendedJobIds
        }).catch(() => {
          this.recommendedJobIds = []
          this.recommendedJobIdsLoaded = true
          return this.recommendedJobIds
        })
      }
    }
  }
</script>

<style scoped>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}

  .job-card-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .job-header-row {
    display: block;
    width: 100%;
    margin-bottom: 10px;
    margin-left: 0;
    padding-left: 0;
    min-width: 0;
    overflow: hidden;
  }

  .job-header-row .recommendation-star {
    display: inline-block;
    margin-left: 2px;
    margin-top: -3px;
    vertical-align: middle;
  }


  .job-employer {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: 0;
    padding-left: 0;
    margin-bottom: 12px;
    min-width: 0;
    clear: both;
  }



  .job-employer .employer-avatar {
    width: 80px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-weight: 600;
    letter-spacing: 0.2px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .job-employer .employer-avatar.has-logo {
    background: transparent;
  }

  .job-employer .employer-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .datatable .result_block .title {
    font-weight: 500;
    font-size: 16px;
    float: none;
    margin: 0;
    padding: 0;
    width: auto;
    max-width: 100%;
    overflow: visible;
    white-space: normal;
    text-overflow: clip;
    color: #4a4a4a;
  }

  .datatable .result_block .job-header-row > .title {
    display: block;
    min-width: 0;
    margin-left: 0;
    padding-left: 0;
  }

  .datatable .result_block .job-employer .title {
    width: auto;
    flex: 0 1 auto;
    font-weight: 400;
    white-space: nowrap;
    margin-left: 0;
    padding-left: 0;
  }
  .facet-title {
    width: auto;
    flex: 0 1 auto;
    font-weight: 400;
    white-space: nowrap;
    margin-left: 0;
    padding-left: 0;
  }
  .datatable .result_block .job-meta-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
    row-gap: 8px;
    width: 100%;
    min-width: 0;
  }


  .datatable .result_block .job-salary-item {
    min-width: 0;
    overflow: hidden;
    max-width: 100%;
  }

  .datatable .result_block .job-type-item {
    min-width: max-content;
  }

  .datatable .result_block .job-salary-item .ace_sec_txt,
  .datatable .result_block .job-salary-item .facet-title {
    display: block;
    flex: 1 1 0%;
    width: 0;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .datatable .result_block .job-type-item .ace_sec_txt,
  .datatable .result_block .job-type-item .facet-title {
    min-width: 0;
    overflow: visible;
    text-overflow: clip;
    white-space: nowrap;
  }


  .job-tags-item {
    flex: 1;
    min-width: 0;
    margin-right: 0;
  }

  .datatable .result_block .job-tags-item .details {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    float: none;
    width: auto;
    max-width: none;
    height: auto;
    overflow: visible;
  }

  .datatable .result_block .job-tags-item .tags_container,
  .datatable .result_block .job-tags-item .tags_cat {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    float: none;
    width: auto;
    max-width: none;
    height: auto;
    margin: 0;
    padding: 0;
    overflow: visible;
  }

  .datatable .result_block .job-tags-item .tags_container {
    flex: 0 0 auto;
    min-width: 0;
  }

  .datatable .result_block .job-tags-item .job-all-tags {
    display: none;
  }

  .datatable .result_block .job-tags-item .tag {
    flex-shrink: 0;
    white-space: nowrap;
    margin: 0 8px 0 0;
  }

  .datatable .result_block .job-tags-item .tag .tag_name {
    overflow: visible;
    text-overflow: clip;
    width: auto;
    max-width: none;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }

  .datatable .result_block .job-tags-item .no_tags .empty_pattern {
    padding: 0;
  }

  .datatable .result_block .job-tags-item .btn_ellipsis {
    float: none;
    margin-top: 0;
    margin-left: 4px;
    flex-shrink: 0;
  }

  .datatable .result_row .thumbnail {
    display: none !important;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    border: none;
  }

  .datatable .result_row {
    position: relative;
    padding: 16px 18px;
    margin: 0 20px 12px 16px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d4d4d4 !important;
    border-radius: 16px !important;
  }

  .datatable .result_row:hover,
  .datatable .result_row:focus {
    background: #fff;
  }

  .datatable .result_row + .result_row {
    border-top-width: 1px !important;
  }

  .datatable .result_row.is-selected,
  .datatable .result_row.is-selected:hover,
  .datatable .result_row.is-selected:focus {
    background: #f3f3f3;
  }

  .datatable .result_row.is-selected:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    width: 14px;
    height: 14px;
    background: #f3f3f3;
    border-top: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    transform: translateY(-50%) rotate(45deg);
  }

  .job-board-page {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }

  .job-board-page > .page_content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }

  .job-board-body {
    display: flex;
    align-items: stretch;
    flex: 1 1 auto;
    width: 100%;
    min-height: 0;
    overflow: hidden;
  }

  .job-board-list {
    width: 35%;
    min-width: 0;
    height: 100%;
    overflow: auto;
    max-height: none;
    min-height: 0;
  }

  .job-board-details {
    width: 65%;
    min-width: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: none;
    min-height: 0;
    border-left: 1px solid #ebebeb;
    background: #fff;
  }

  .job-details-empty {
    padding: 24px 16px;
  }

  .job-board-list .search_result_container {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .job-board-list .search_result_container > [class*="col"] {
    padding-left: 0;
    padding-right: 0;
  }

  .job-board-list .list-group {
    margin-bottom: 0;
    padding-top: 12px;
    padding-bottom: 12px;
    background: transparent;
    border: none;
  }

  .job-board-details .page_content {
    padding: 0 1px 24px;
    max-width: 100%;
    overflow-x: hidden;
  }

  .job-board-details .page-heading {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    max-width: 100%;
  }

  .job-board-details .container-fluid {
    max-width: 100%;
    padding-left: 15px;
    padding-right: 15px;
  }

  .job-board-details .page-content-section {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    max-width: 100%;
  }

  .job-board-details .page-content-section .left-container {
    max-width: 100%;
  }

  .datatable {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }

  .explore_entity_result {
    margin-left: 0;
    margin-right: 0;
  }

  .search_result_container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }

  .datatable .result_row .result_block {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    float: none;
    margin-left: 0;
    overflow: hidden;
  }

  .job-board-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 auto;
    width: 100%;
    padding: 5px 5px;
    background: #fff;
    flex-wrap: nowrap;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
  .toolbar-right .out-of-total-item {
    margin-right: 10px;
  }
  .toolbar-left .explore_filter {
    position: relative;
    float: none;
    display: flex;
    align-items: center;
  }

  .toolbar-left .explore_filter .dropdown_popover {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
  }



  .toolbar-left .form-field {
    padding: 0 10px;
    display: flex;
    align-items: center;
    margin-right: 8px;
    border-radius: 4px;
    border: none;
    color: #000 !important;
  }

  .toolbar-left .form-field:hover,
  .toolbar-left .form-field:focus,
  .toolbar-left .form-field:active {
    color: #000 !important;
  }

  .toolbar-left .form-field label,
  .toolbar-left .form-field .txt_sh,
  .toolbar-left .form-field  {
    color: #000 !important;
  }
  .toolbar-left .form-field,
  .toolbar-left .form-field label,
  .toolbar-left .form-field .txt_sh,
  .toolbar-left .form-field .icon-dropdown1 {
    cursor: pointer;
  }

  .toolbar-left .form-field label {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .toolbar-left .form-field .icon-dropdown1 {
    float: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    position: relative;
    top: 2px;
  }

  .toolbar-left .employer-filter,
  .toolbar-left .employer-filter:hover,
  .toolbar-left .employer-filter:focus {
    background: #7ad8f0 !important;
    color: #000 !important;
  }

  .toolbar-left .job-type-filter,
  .toolbar-left .job-type-filter:hover,
  .toolbar-left .job-type-filter:focus {
    background: #ffb0c4 !important;
    color: #000 !important;
  }

  .toolbar-left .salary-filter,
  .toolbar-left .salary-filter:hover,
  .toolbar-left .salary-filter:focus {
    background: #c8e6c0 !important;
    color: #000 !important;
  }

  .toolbar-left .distance-filter,
  .toolbar-left .distance-filter:hover,
  .toolbar-left .distance-filter:focus {
    background: #d4c5f0 !important;
    color: #000 !important;
  }


  .toolbar-left .recommended-filter,
  .toolbar-left .recommended-filter:hover,
  .toolbar-left .recommended-filter:focus {
    background: #fff8dc !important;
    color: #000 !important;
  }

  .toolbar-left .recommended-filter.is-active,
  .toolbar-left .recommended-filter.is-active:hover,
  .toolbar-left .recommended-filter.is-active:focus {
    background: #f6e59b !important;
  }

  .toolbar-left .recommended-filter .icon-star-full {
    color: #ffd700;
    margin-right: 6px;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }
  .job-board-filter-tags .filter-tag .employer-tag {
    background-color: #7ad8f0;
  }

  .job-board-filter-tags .filter-tag .job-type-tag {
    background-color: #ffb0c4;
  }

  .job-board-filter-tags .filter-tag .salary-tag {
    background-color: #c8e6c0;
  }

  .job-board-filter-tags .filter-tag .distance-tag {
    background-color: #d4c5f0;
  }

  .job-board-filter-tags .filter-tag .job-applied-tag {
    background-color: #f6e59b;
  }

  .job-board-filter-tags .filter-tag .recommended-tag {
    background-color: #fff8dc;
  }

</style>

<style>
  /* Popover is injected by bootstrap-vue, so these cannot be scoped. */
  .job-board-page .explore_filter_container .popover {
    transform: none !important;
    top: 42px !important;
    left: 0px !important;
    margin: 0px !important;
    min-width: 440px;
  }

  .job-board-page .explore_filter_container .popover .popover-body {
    padding: 0px;
  }

  .job-board-page .explore_filter_container .popover .arrow:before,
  .job-board-page .explore_filter_container .popover .arrow:after {
    content: none !important;
  }

  .job-board-page .explore_filter_container .popup_content {
    overflow: auto;
    max-height: calc(100vh - 360px);
    padding-bottom: 5px;
  }

  .job-board-page .explore_filter_container .field-row {
    padding: 2px 15px;
    display: flex;
    align-items: center;
    margin-top: 7px;
    width: 100%;
  }

  .job-board-page .explore_filter_container .field-row > input[type="checkbox"] {
    margin: 2px 6px 0 0;
    width: 16px;
    height: 16px;
    min-width: 16px;
    flex-shrink: 0;
  }

  .job-board-page .explore_filter_container .field-row > label {
    margin: 0;
    line-height: 22px;
    cursor: pointer;
  }

  .job-board-page .explore_filter_container .field-row .form-check,
  .job-board-page .sort_by_popover .field-row .form-check {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    margin: 0;
    padding-left: 0;
    min-height: 22px;
  }

  .job-board-page .explore_filter_container .field-row .form-check input,
  .job-board-page .sort_by_popover .field-row .form-check input {
    position: relative;
    top: 2px;
    float: none;
    margin: 0;
    width: 16px;
    height: 16px;
    min-width: 16px;
    flex-shrink: 0;
  }

  .job-board-page .explore_filter_container .field-row .form-check-label,
  .job-board-page .sort_by_popover .field-row .form-check-label {
    margin: 0;
    padding: 0;
    line-height: 22px;
  }

  .job-board-page .explore_filter_container .field-row.distance-location-row label {
    margin-bottom: 4px;
  }

  .job-board-page #distanceDropDownPopup .popup_content {
    overflow: visible;
  }

  .job-board-page #distanceDropDownPopup .distance-popup-actions {
    display: flex;
    justify-content: flex-end;
    clear: both;
    width: 100%;
  }

  .job-board-page #distanceDropDownPopup .distance-popup-actions .range-button {
    float: none;
  }

  .job-board-page .explore_filter_container .distance-state-select input,
  .job-board-page .explore_filter_container .distance-state-select input[type="search"] {
    width: 0;
    min-width: 0;
    flex: 1 1 auto;
    height: 24px;
    margin: 0;
    padding: 0;
    border: none;
    box-shadow: none;
  }

  .job-board-page .explore_filter_container .distance-state-select.open input,
  .job-board-page .explore_filter_container .distance-state-select.open input[type="search"] {
    width: auto;
    min-width: 40px;
  }

  .job-board-page .explore_filter_container .distance-state-select .selected-tag {
    flex: 1 1 auto;
    max-width: none;
    margin: 0 4px 0 0;
    padding: 0;
    border: none;
    background: transparent;
    line-height: 24px;
    white-space: nowrap;
    overflow: visible;
  }

  .job-board-page .explore_filter_container .distance-state-select .dropdown-menu {
    max-height: 180px;
    overflow-y: auto;
    z-index: 20;
  }

  .job-board-page .explore_filter_container .distance-state-select .dropdown-menu li > a {
    text-align: left;
    padding: 4px 8px;
  }

  .job-board-page .explore_filter_container .range-button {
    float: right;
    margin-right: 17px;
    margin-bottom: 15px;
    margin-top: 14px;
  }

  .job-board-details .thumbnail-section {
    display: none !important;
  }

  .job-board-details .page-content-section .left-container {
    float: none !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .job-board-details .job-description {
    width: 100%;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .job-board-details .job-summary .tag {
    width: auto;
    float: none;
  }

  .job-board-details .job-meta-row {
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/app/search/components/JobBoard.vue